var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4942 12.496C17.4942 12.9379 17.3187 13.3617 17.0062 13.6742C16.6937 13.9866 16.2699 14.1622 15.8281 14.1622H5.83128L2.49902 17.4944V4.1654C2.49902 3.72351 2.67456 3.29973 2.98702 2.98727C3.29948 2.67481 3.72327 2.49927 4.16515 2.49927H15.8281C16.2699 2.49927 16.6937 2.67481 17.0062 2.98727C17.3187 3.29973 17.4942 3.72351 17.4942 4.1654V12.496Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.6b7d501b87db076c8aaf9eb37fa1e0cb.svg";
export { ForwardRef as ReactComponent };